/**
 * 平台产品切换
 */



// WEBPACK FOOTER //
// ./src/vuex/modules/rcproduct.js